import { render, staticRenderFns } from "./TicketsV2.vue?vue&type=template&id=e87be016&scoped=true"
import script from "./TicketsV2.vue?vue&type=script&lang=js"
export * from "./TicketsV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87be016",
  null
  
)

export default component.exports